import { useAction } from './useAction';
import { useCallback } from 'react';
import { amplitudeActions } from '@sonar-software/sonar-analytics';
export function useAmplitude() {
    const logEventAction = useAction(amplitudeActions.requestAmplitudeEvent);
    return useCallback((event, data) => {
        if (typeof event === 'string') {
            logEventAction({
                data,
                id: event
            });
        }
        else {
            logEventAction(event);
        }
    }, [logEventAction]);
}
